export default __webpack_public_path__ + "static/media/triangle_3.7e6d69df.svg";